"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlantDirection = exports.Slant = void 0;
const core_1 = require("@openhps/core");
let Slant = class Slant {
    constructor() {
        this.direction = SlantDirection.DOWN;
    }
};
exports.Slant = Slant;
__decorate([
    (0, core_1.SerializableMember)(),
    __metadata("design:type", Number)
], Slant.prototype, "direction", void 0);
exports.Slant = Slant = __decorate([
    (0, core_1.SerializableObject)()
], Slant);
var SlantDirection;
(function (SlantDirection) {
    SlantDirection[SlantDirection["DOWN"] = 0] = "DOWN";
})(SlantDirection || (exports.SlantDirection = SlantDirection = {}));
//# sourceMappingURL=Slant.js.map